import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-content-overlay',
  templateUrl: './content-overlay.component.html',
  styleUrls: ['./content-overlay.component.scss']
})
export class ContentOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
